// extracted by mini-css-extract-plugin
export default {"clearOption":"richSelectOptionRenderer_clearOption__vf6Bg"};